import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { Button } from "../components/ui/button";
import { Field, Input } from "../components/ui/form";
import { meQuery } from "../lib/session";
import { authClient } from "../lib/auth-client";
import { AuthLayout } from "./auth-layout";

export function LoginPage() {
  const { redirect } = useSearch({ from: "/login" });
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);
    const { error: signInError } = await authClient.signIn.email({ email, password });
    if (signInError) {
      setError(signInError.message ?? "Sign-in failed");
      setPending(false);
      return;
    }
    await queryClient.invalidateQueries({ queryKey: meQuery.queryKey });
    if (redirect) await navigate({ href: redirect });
    else await navigate({ to: "/" });
  }

  return (
    <AuthLayout
      title="Sign in"
      description="Staff access to the Lucky Try catalog and analytics."
      footer={
        <Link to="/forgot-password" className="hover:text-body">
          Forgot your password?
        </Link>
      }
    >
      <form className="flex flex-col gap-3" onSubmit={submit}>
        <Field label="Email">
          <Input
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Field>
        <Field label="Password">
          <Input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </Field>
        {error && <p className="text-danger-text text-caption">{error}</p>}
        <Button type="submit" variant="primary" disabled={pending} className="mt-1">
          {pending ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthLayout>
  );
}
